/* Latest on Instagram: fills the Gallery (and the home page's Recent work) from @midnight_autoworkss.
   Photos come from the MA worker (/ig/feed), refreshed hourly. If the feed is empty or down, nothing changes. */
(function(){
  var base = (window.MA_CHAT_URL || 'https://midnight-chat.throbbing-hill-894c.workers.dev/').replace(/\/?$/, '/');
  var IG = 'https://www.instagram.com/midnight_autoworkss/';
  if (window.MA_GALLERY && window.MA_GALLERY.length) return; // hand-picked gallery photos take priority
  function img(it){ return it.img || ''; }
  function line(it){ var c = String(it.caption || '').split('\n')[0].replace(/#\S+/g, '').replace(/[^\w\s&'’.\-\/]+/g, ' ').replace(/\s+/g, ' ').trim(); var m = c.match(/^(.{3,40}?)\s+(?:in for|in for our|in\s|getting|with|got|had|for)\b/i); c = m ? m[1] : c.split(' ').slice(0, 4).join(' '); return c.length > 32 ? c.slice(0, 30).trim() + '…' : c; }
  function tile(it, cls, capCls){
    var a = document.createElement('a'); a.className = cls + ' igtile'; a.href = it.url || IG; a.target = '_blank'; a.rel = 'noopener';
    var t = line(it); a.setAttribute('aria-label', 'Open on Instagram' + (t ? ': ' + t : ''));
    var im = document.createElement('img'); im.src = img(it); im.alt = t || 'Midnight Autoworks on Instagram'; im.loading = 'lazy'; im.decoding = 'async'; a.appendChild(im);
    if (it.type === 'VIDEO'){ var v = document.createElement('i'); v.className = 'igplay'; v.setAttribute('aria-hidden', 'true'); a.appendChild(v); }
    if (t){ var c = document.createElement('span'); c.className = capCls; c.textContent = t; a.appendChild(c); }
    return a;
  }
  function css(){
    var s = document.createElement('style');
    s.textContent = '.igtile{display:block;position:relative;text-decoration:none;color:inherit}.igtile img{display:block;width:100%;height:100%;object-fit:cover}'
      + '.igplay{position:absolute;top:10px;right:10px;width:26px;height:26px;border-radius:50%;background:rgba(11,11,12,.6)}'
      + '.igplay:after{content:"";position:absolute;left:10px;top:7px;border-style:solid;border-width:6px 0 6px 9px;border-color:transparent transparent transparent #F1ECE1}'
      + '.ighead{display:block;margin:0 0 16px;line-height:1.5;color:#CFC8BA;font-size:15px}.ighead a{color:#CCB06A;text-decoration:none;font-weight:600}';
    document.head.appendChild(s);
  }
  fetch(base + 'ig/feed', {credentials: 'omit'}).then(function(r){ return r.ok ? r.json() : null; }).then(function(j){
    var items = (j && j.items || []).filter(function(it){ return img(it); });
    if (!items.length) return;
    css();
    var wall = document.getElementById('gWall');
    if (wall && !wall.children.length){
      var empty = document.getElementById('gEmpty'), follow = document.getElementById('gFollow');
      if (empty) empty.hidden = true;
      var h = document.createElement('p'); h.className = 'ighead';
      h.appendChild(document.createTextNode('Latest from our studio on Instagram · '));
      var hl = document.createElement('a'); hl.href = IG; hl.target = '_blank'; hl.rel = 'noopener'; hl.textContent = '@midnight_autoworkss'; h.appendChild(hl);
      wall.parentNode.insertBefore(h, wall);
      items.forEach(function(it){ wall.appendChild(tile(it, 'gtile', 'gcap')); });
      if (follow) follow.hidden = false;
    }
    var grid = document.getElementById('rwGrid');
    if (grid && !grid.querySelector('img')){
      grid.textContent = '';
      items.slice(0, 6).forEach(function(it){ grid.appendChild(tile(it, 'rwtile', 'rwcap')); });
      var sec = document.getElementById('recent-work'); if (sec) sec.style.display = '';
    }
  }).catch(function(){});
})();
